/**
 * 对话框
 * Bai.Zhiming
 * 2019-7-11
 */
angular.module("dialogBoxModule", [
    'chartEditorModule',
    'scrollTopLoadMoreModule',
    'dialogBoxC2CModule',
    'dialogBoxGroupModule',
    'imUploadFileModule',
    'emotionsModule'
]);